(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // RequireJS
    define([], factory(fetch));
  } else if (typeof module === 'object' && module.exports) {
    // NodeJs
    module.exports = factory(require('node-fetch'));
  } else {
    // Browser
    root.returnExports = factory(fetch);
  }
}(this, function (_fetch) {
  return {
    /**
     * @param object userInfo
     * @param object appealInfo
     * @param object deviceInfo
     * @param object advertisementInfo
     * @param string url
     * @param object additionalParam
     * Все входные параметры описаны в документации к модулю https://gitlab.decluster.ria.com/bu-auto-modules/bpm#bpm
     *
     */
    sendImpressions: function (userInfo, appealInfo, deviceInfo, advertisementInfo, url, additionalParam) {
      var advertisementInfo = advertisementInfo || {};
      var userInfo = userInfo || {};
      var deviceInfo = deviceInfo || {};
      var url = url || '/users/sendImpressions/';
      var additionalParam = additionalParam || { sendToCM: true, sendToBPM: true };

      var complaintTypeDefault = ['Скарги', 'Відгуки', 'Модерація', 'Мобільний додаток', 'Безпека', 'Інше'];
      var complaintType = appealInfo.complaintType || complaintTypeDefault[appealInfo.typeReview - 1];
      // Привожу номера телефонов в нужный формат(Удаляю все символы кроме чисел)
      var advertisementPhone;
      var complainerPhone;

      if (userInfo.phones) {
        complainerPhone = userInfo.phones.split(',')[0].replace(/[^0-9$]/g, '') || '';
        complainerPhone = complainerPhone.slice(-10);
      }

      if (advertisementInfo.phones) {
        advertisementPhone = advertisementInfo.phones.split(',')[0].replace(/[^0-9$]/g, '');
        advertisementPhone = advertisementPhone.slice(-10);
      }

      var isMobile = deviceInfo.isMobile;
      var isApp = deviceInfo.isApp;

      var deviceType = isMobile ? 'Мобільний' : 'Десктоп';
      var phone = Number(complainerPhone) || '';

      var reasonByDevice = isApp
          ? (appealInfo.source !== 'search_rate' ? 'Тип скарги: ' + appealInfo.complainName : '')
          : 'Причина: ' + complaintType;

      var appealFile = appealInfo.titleFeedback !== 'Оценка поиска (Моб. приложение)' ? appealInfo.appellateInfo : '';

      // Строка для отображения хронологии в ВРМ
      var body = 'Тема:' + appealInfo.titleFeedback +
          '\n' + reasonByDevice +
          '\nСторінка: ' + (appealInfo.link ? appealInfo.link : '') +
          (appealInfo.advLink ? '\nПосилання на сторінку авто: ' + appealInfo.advLink : '') +
          '\nПовідомлення користувача: ' + appealInfo.textFeedback +
          '\n' +
          '\nID клієнта: ' + userInfo.user_id +
          '\nІм\'я клієнта: ' + userInfo.fio +
          '\nEmail: ' + userInfo.email +
          '\nТелефон: ' + phone +
          '\nФайли: ' + (advertisementInfo.files ? advertisementInfo.files.join('  |  ') : '') +
          '\n' +
          '\n' + appealFile +
          '\n' +
          '\nТип пристрою: ' + deviceType +
          '\nОпераційна система: ' + deviceInfo.platform +
          '\nВерсія додатку: ' + deviceInfo.appVersion +
          '\nЕкран: ' + deviceInfo.screenWidth + 'x' + deviceInfo.screenHeight;

      var department = appealInfo.department || 'auto';
      var reasonName = additionalParam.reasonName || '';

      var email = userInfo.email
          || [userInfo.user_id || userInfo.ui, 'noreply@auto.ria.com'].join('-');

      // Подготовка данных для ВРМ
      var feedbackData = {
        user: {
          email: email,
          fio: userInfo.fio,
          phone: phone,
          user_id: userInfo.user_id,
          web_id: userInfo.ui || '',
        },
        ticket: {
          departament: department,
          title: appealInfo.titleFeedback,
          body: appealInfo.ticketType === 'feedbackAboutApp' ? appealInfo.ticketBody : body,
          type: appealInfo.typeReview,
          feedbackType: appealInfo.feedbackType || '',
          return_ticket_id: 1,
          complaint_type: isApp ? reasonName : complaintType,
          complaint_type_guid: advertisementInfo.autoHash,
          rating_type_guide: advertisementInfo.sellerHash,
          complaint_text: appealInfo.textFeedback,
          user_ad_id: advertisementInfo.userId || '',
          rating_id: advertisementInfo.ratingId || '',
          rating: advertisementInfo.rating || 0,
          files: advertisementInfo.files || '',
          ad_link: advertisementInfo.link || '',
          ad_id: advertisementInfo.id || '',
          complaint_phone: advertisementPhone || '',
          user_ad_phone: advertisementPhone || '',
          case_page: appealInfo.link,
          internet_inspector: appealInfo.internetInspector,
          complainer_info: {
            complainer_user_id: userInfo.user_id,
            complainer_name: userInfo.fio,
            complainer_phone: phone,
            complainer_email: userInfo.email,
          },
          adv_info: {
            marka: advertisementInfo.markaName || '',
            model: advertisementInfo.modelName || '',
            year: advertisementInfo.year || 0,
            price: advertisementInfo.sellerPrice || '',
            seller_name: advertisementInfo.ownerName || '',
            seller_link: advertisementInfo.link || '',
            photo_link: advertisementInfo.photoLink || 'https://img6.auto.ria.com/images/nophoto/no-photo-620x495.jpg',
          },
          account_manager: {
            manager_name: advertisementInfo.managerName,
          },
          system: {
            browser: deviceInfo.userAgent,
          },
          device: {
            device_type: deviceType,
            app_version: deviceInfo.appVersion,
            os: {
              version: '',
              name: deviceInfo.platform,
              device: deviceType,
            },
            screen: {
              width: deviceInfo.screenWidth,
              height: deviceInfo.screenHeight,
            },
          },
        },
      };

      // Подготовка данных для mailer
      var mailerData = {
        data: JSON.stringify(feedbackData),
        subject: appealInfo.titleFeedback,
        additionalParam: JSON.stringify(additionalParam),
      };

      var headers = {
        'Content-Type': 'application/json',
      };
      if (isApp) {
        headers.Cookie = 'PSP_ID=' + userInfo.PSP_ID + ';' + 'ui=' + userInfo.ui + ';';
      }

      return _fetch(url, {
        method: 'post',
        body: JSON.stringify(mailerData),
        headers: headers,
      })
      .then(function (response) {
        return Promise.all([
          response,
          response.json()])
      })
      .then(function(response){
        var result;
        if(response[1].hasOwnProperty('isSpam')){
          return response[1]
        }
        if (response[0].status !== 200) {
          result = 'Feedback not delivered. Status != 200';
        } else {
          result = true;
        }
        return result;
      },
      function(err){
        console.error(err)
        return 'Feedback not delivered. Status != 200';
      })
    },
  };
}));
